/**
 * Format a number as currency
 */
export function formatCurrency(value: number | undefined, compact = false): string {
  if (value === undefined || value === null) return 'N/A';

  if (compact) {
    if (value >= 1000000) {
      return `$${(value / 1000000).toFixed(1)}M`;
    }
    if (value >= 1000) {
      return `$${Math.round(value / 1000)}K`;
    }
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

/**
 * Format a number as percentage
 */
export function formatPercent(value: number | undefined, decimals = 1): string {
  if (value === undefined || value === null) return 'N/A';
  return `${(value * 100).toFixed(decimals)}%`;
}

/**
 * Format a percentage value (already in percent form)
 */
export function formatPercentValue(value: number | undefined, decimals = 1): string {
  if (value === undefined || value === null) return 'N/A';
  return `${value.toFixed(decimals)}%`;
}

/**
 * Format a number with commas
 */
export function formatNumber(value: number | undefined): string {
  if (value === undefined || value === null) return 'N/A';
  return new Intl.NumberFormat('en-US').format(value);
}

/**
 * Format square footage
 */
export function formatSqft(value: number | undefined): string {
  if (value === undefined || value === null) return 'N/A';
  return `${formatNumber(value)} sqft`;
}
